module.exports = __webpack_public_path__ + "img/318.1dd7d81e.jpg";